import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { SmsLog, SmsLogParams } from './smsLogs.types';

export const getSmsLogsList = (client: AxiosInstance) => async (params: SmsLogParams) => {
  return (await client.get<PaginatedApiResponse<SmsLog[]>>(API_ROUTES.GET_SMS_LOG_LIST, { params })).data;
};

export const smsLogsQueries = {
  all: () => ['sms-log'],
  list: (params: SmsLogParams) =>
    queryFactoryOptions<PaginatedApiResponse<SmsLog[]>>({
      queryKey: [...smsLogsQueries.all(), 'list', params],
      queryFn: (client) => () => getSmsLogsList(client)(params),
    }),
};
